import {
    createOverlayComponent,
    IOverlayBusinessLogic,
} from '@vfde-brix/overlay';

let overlay;

/**
 * Overlay implementation
 *
 *
 * @param toggleOverlay
 */
export const mountOverlay = (toggleOverlay) => {

    const element = document.createElement('div');
    document.body.appendChild(element);

    const properties: IOverlayBusinessLogic = {
        onClose: () => {
            toggleOverlay();
        },
        onOpen: (overlay) => {
            // handleLegacyClickEventBindings(overlay);
        },
    };

    overlay = createOverlayComponent(element, {business: properties});

    return overlay;
};

/**
 * Show the overlay
 *
 * @param overlayContent - Pass the response so that the overlay can inject its content
 */
export const showOverlay = (overlayContent: string): void => {
    overlay.injectContent(overlayContent);
    overlay.open();
};
